<template>
  <section>
    <div class="case-creation__body pb-0">
      <div class="vue-form">
        <el-form :model="patientInformationFormData" ref="ruleForm">
          <el-row :gutter="30">
            <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">
                    First Name
                    <span class="star">*</span>
                  </label>
                  <el-input
                    v-model="patientInformationFormData.first_name"
                    placeholder="Enter First Name"
                    :clearable="true"
                    class="el-input"
                    
                  ></el-input>

                  <p
                    class="err"
                    v-if="
                      getCaseCreationValidationErrors &&
                      getCaseCreationValidationErrors['patient_info.first_name']
                    "
                  >
                    {{
                      getCaseCreationValidationErrors["patient_info.first_name"]
                    }}
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">
                    Last Name
                    <span class="star">*</span>
                  </label>
                  <el-input
                    v-model="patientInformationFormData.last_name"
                    placeholder="Enter Last Name"
                    :clearable="true"
                    class="el-input"
                    
                  ></el-input>
                  <p
                    class="err"
                    v-if="
                      getCaseCreationValidationErrors &&
                      getCaseCreationValidationErrors['patient_info.last_name']
                    "
                  >
                    {{
                      getCaseCreationValidationErrors["patient_info.last_name"]
                    }}
                  </p>
                </el-form-item>
              </div>
            </el-col>

            <el-col :xl="3" :lg="3" :md="12" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">
                    Gender
                    <span class="star">*</span>
                  </label>
                  <div class="gender-select">
                    <el-select
                      v-model="patientInformationFormData.gender"
                      placeholder="Select Gender"
                      filterable
                      default-first-option
                      @change="handlePregnancyData"  
                         
                      clearable                 
                    >
                      <el-option
                        v-for="(gender, index) in genderOptions"
                        :key="index"
                        :label="gender"
                        :value="gender"
                      ></el-option>
                    </el-select>
                    <p
                      class="err"
                      v-if="
                        getCaseCreationValidationErrors &&
                        getCaseCreationValidationErrors['patient_info.gender']
                      "
                    >
                      {{
                        getCaseCreationValidationErrors["patient_info.gender"]
                      }}
                    </p>
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="5" :md="12" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <dobVersion
                    v-show="showPatientDob"
                    :dobData="patientInformationFormData"
                    :validataionErrors="getCaseCreationValidationErrors"
                    :errorKey="'patient_info.date_of_birth'"
                    ref="dobField"
                    :readonly="true"
                  >
                  </dobVersion>
                </el-form-item>
              </div>
            </el-col>

            <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">EMR #</label>
                  <el-input
                    placeholder="Enter EMR"
                    v-model="patientInformationFormData.emr"
                  ></el-input>
                  <p
                    class="err"
                    v-if="
                      getCaseCreationValidationErrors &&
                      getCaseCreationValidationErrors.emr
                    "
                  >
                    {{ getCaseCreationValidationErrors.emr }}
                  </p>
                </el-form-item>
              </div>
            </el-col>

            <el-col :xl="3" :lg="4" :md="8" :sm="8" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"
                    >Mobile Number
                    <span class="star">*</span>
                  </label>
                  <el-input
                    suffix-icon="el-icon-mobile-phone"
                    placeholder="Enter Mobile Number"
                    v-model="patientInformationFormData.home_phone"
                    maxlength="10"
                    
                  ></el-input>
                  <p
                    class="err error-break"
                    v-if="
                      getCaseCreationValidationErrors &&
                      getCaseCreationValidationErrors['patient_info.home_phone']
                    "
                  >
                    {{
                      getCaseCreationValidationErrors["patient_info.home_phone"]
                    }}
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="8" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Phone Number</label>
                  <el-input
                    suffix-icon="el-icon-mobile-phone"
                    placeholder="Enter Phone Number"
                    v-model="patientInformationFormData.work_phone"
                    maxlength="10"
                    
                  ></el-input>
                  <p
                    class="err"
                    v-if="
                      getCaseCreationValidationErrors &&
                      getCaseCreationValidationErrors['patient_info.work_phone']
                    "
                  >
                    {{
                      getCaseCreationValidationErrors["patient_info.work_phone"]
                    }}
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Email</label>
                  <el-input
                    class="email-lower"
                    type="email"
                    suffix-icon="el-icon-message"
                    placeholder="Enter Email"
                    v-model="patientInformationFormData.email"
                  ></el-input>
                  <p
                    class="err"
                    v-if="
                      getCaseCreationValidationErrors &&
                      getCaseCreationValidationErrors.email
                    "
                  >
                    {{ getCaseCreationValidationErrors.email }}
                  </p>
                </el-form-item>
              </div>
            </el-col>

            <el-col :xl="7" :lg="8" :md="8" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"
                    >Address Line 1
                    <span class="star">*</span>
                  </label>
                  <el-input
                    type="text"
                    placeholder="Enter Address Line 1"
                    @blur="onBlurAddress"
                    v-model="patientInformationFormData.address_line_1"
                  ></el-input>
                  <p
                    class="err"
                    v-if="
                      getCaseCreationValidationErrors &&
                      getCaseCreationValidationErrors[
                        'patient_info.address_line_1'
                      ]
                    "
                  >
                    {{
                      getCaseCreationValidationErrors[
                        "patient_info.address_line_1"
                      ]
                    }}
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="7" :lg="8" :md="8" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Address Line 2</label>
                  <el-input
                    type="text"
                    placeholder="Enter Address Line 2"
                    v-model="patientInformationFormData.address_line_2"
                  ></el-input>
                  <p
                    class="err"
                    v-if="
                      getCaseCreationValidationErrors &&
                      getCaseCreationValidationErrors.address_line_2
                    "
                  >
                    {{ getCaseCreationValidationErrors.address_line_2 }}
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">County</label>
                  <el-input
                    v-model="patientInformationFormData.county"
                    
                  ></el-input>
                  <p
                    class="err"
                    v-if="
                      getCaseCreationValidationErrors &&
                      getCaseCreationValidationErrors.county
                    "
                  >
                    {{ getCaseCreationValidationErrors.county }}
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">
                    Zip
                    <span class="star">*</span>
                  </label>
                  <el-input
                    maxlength="5"
                    placeholder="Enter zip"
                    v-model="patientInformationFormData.zip"
                    @input="getStateCity"
                    
                  ></el-input>
                  <p
                    class="err"
                    v-if="
                      getCaseCreationValidationErrors &&
                      getCaseCreationValidationErrors['patient_info.zip']
                    "
                  >
                    {{ getCaseCreationValidationErrors["patient_info.zip"] }}
                  </p>
                </el-form-item>
              </div>
            </el-col>

            <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <state
                    :stateData="patientInformationFormData"
                    @onchange="onBlurAddress"
                    :validataionErrors="getCaseCreationValidationErrors"
                    :errorKey="'patient_info.state'"
                  ></state>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="24">
              <div class="case-creation__input">
                <el-form-item>
                  <city
                    :cityData="patientInformationFormData"
                    @onchange="onBlurAddress"
                    :validataionErrors="getCaseCreationValidationErrors"
                    :errorKey="'patient_info.city'"
                  ></city>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">&nbsp;</label>
                  <div class="verify-address-btn">
                    <el-button :disabled="hasAddress" @click="verifyAddress"
                      >Verify Address</el-button
                    >
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col
              :xl="4"
              :lg="3"
              :md="8"
              :sm="12"
              :xs="12"
              v-if="patientInformationFormData.gender == 'FEMALE'"
            >
              <div class="pregancy-field">
                <label for="">Pregnancy </label>
                <el-form-item class="text mb-0">
                  <el-checkbox
                    class="el-checkbox-group"
                    v-model="patientInformationFormData.pregnant"
                    size="large"
                  />
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="default-modal" v-if="this.addressData">
      <el-dialog v-model="verifyAddressPopup">
        <div class="dialog-header">
          <span class="header-part">
            The address you entered was found but more information is needed
          </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="verifyAddressPopup = false"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
          </el-button>
        </div>
        <div class="address-data-fields">
          <ul class="address-lists">
            <li>
              <p class="name">Address</p>
              <span class="value"> : {{ this.addressData.Address1 }} </span>
            </li>
            <li>
              <p class="name">Zip</p>
              <span class="value"> : {{ this.addressData.Zip5 }} </span>
            </li>
            <li>
              <p class="name">State</p>
              <span class="value"> : {{ this.addressData.State }} </span>
            </li>
            <li>
              <p class="name">City</p>
              <span class="value"> : {{ this.addressData.City }} </span>
            </li>
          </ul>
          <div class="dialog-footer">
            <el-button class="blue-save-button" @click="fillAddressData">
              Update Address
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
const state = defineAsyncComponent(() => import("@/components/misc/State"));
const city = defineAsyncComponent(() => import("@/components/misc/City"));
const dobVersion = defineAsyncComponent(() =>
  import("@/components/misc/DobNewFormat")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  props: ["patientInfo"],
  data() {
    return {
      //patient information
      verifyAddressPopup: false,
      addressData: {},
      verifyButtonLoading: false,
      patientInformationFormData: {
        first_name: "",
        last_name: "",
        gender: "",
        date_of_birth: "",
        emr: "",
        home_phone: "",
        work_phone: "",
        email: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        state: "",
        county: "",
        zip: "",
        zip_extension: "",
        pregnant: false,
      },
      genderOptions: caseConstants.genderOptions,
      show: false,
      showDob: false,
      showPatientDob: false,
      loadDateOfBirth: false,
    };
  },
  components: {
    state,
    city,
    dobVersion,
  },
  computed: {
    ...mapGetters("cases", [
      "getStateAndCity",
      "getAddress",
      "getVerifyAddress",
    ]),
    ...mapGetters("emrOrders", [
      "getSingleEMROrder",
      "getCaseCreationValidationErrors",
    ]),
    hasAddress() {
      if (
        this.patientInformationFormData.address_line_1 &&
        this.patientInformationFormData.zip &&
        this.patientInformationFormData.state &&
        this.patientInformationFormData.city
      ) {
        return false;
      }
      return true;
    },

    ...mapGetters("cases", ["getStateAndCity"]),
    ...mapGetters("emrOrders", [
      "getSingleEMROrder",
      "getCaseCreationValidationErrors",
    ]),
  },
  mounted() {
    this.loadInitData();
  },
  methods: {
    async handlePregnancyData() {
      if (this.patientInformationFormData.gender != "FEMALE") {
        this.patientInformationFormData.pregnant = false;
      }
    },
    checkPatientDob() {
      if (this.patientInformationFormData) {
        return this.$refs.dobField.checkValidDOBDate();
      }
    },
    async fillAddressData() {
      if (this.addressData) {
        this.verifyAddressPopup = false;
        this.patientInformationFormData.address_line_1 =
          this.addressData.Address1;
        this.patientInformationFormData.zip = this.addressData.Zip5;
        this.patientInformationFormData.state = this.addressData.State;
        this.patientInformationFormData.city = this.addressData.City;
        this.$notify.success({
          title: "Success",
          message: "Verified address updated successfully",
        });
      }
    },
    async onBlurAddress() {
      if (this.patientInformationFormData?.zip?.length === 5 && !this.hasAddress) {
        await this.verifyAddress();
      }
    },
    async verifyAddress() {
      try {
        this.loading = true;
        let params = {
          address1: this.patientInformationFormData.address_line_1,
          address2: this.patientInformationFormData.address_line_2,
          zip: this.patientInformationFormData.zip,
          city: this.patientInformationFormData.city,
          state: this.patientInformationFormData.state,
        };
        await this.$store.dispatch("cases/fetchAddressVerification", params);
        if (
          this.getVerifyAddress &&
          this.getVerifyAddress.misMatch &&
          this.getVerifyAddress.misMatch == true
        ) {
          this.addressData = this.getVerifyAddress.data;
          this.patientInformationFormData.zip_extension = this.addressData.Zip4 || "";
          this.verifyAddressPopup = true;
        } else if (this.getVerifyAddress) {
          this.patientInformationFormData.zip_extension = this.getVerifyAddress?.data?.Zip4 || "";
          successNotification("Address verified successfully");
        } else {
          if (!this.getVerifyAddress) {
            errorNotification("Error at verifying address");
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async loadInitData() {
      this.show = true;
      this.showPatientState = true;
      this.showPatientDob = true;
      this.showDob = true;
      if (this.$route.params.order_id) {
        this.orderId = this.$route.params.order_id;
        this.checkCaseInfo();
      }
    },
    checkCaseInfo() {
      if (this.getSingleEMROrder && this.getSingleEMROrder.patient_info) {
        this.patientInformationFormData = {
          ...this.getSingleEMROrder.patient_info,
        };
        if (this.patientInformationFormData?.zip) {
          // Trim the zip to the first 5 characters
          const trimmedZip = this.patientInformationFormData.zip.slice(0, 5);

          // Update the patient_info.zip value
          this.patientInformationFormData.zip = trimmedZip;
          this.onBlurAddress();
        }
      }
    },
    formatPatientInfo() {
      return this.parsePatientInfo(this.patientInformationFormData);
    },

    async getStateCity() {
      try {
        let params = {
          zip: this.patientInformationFormData.zip,
        };
        await this.$store.dispatch("cases/getStateCity", params);
        if (this.getStateAndCity) {
          this.patientInformationFormData.state = this.getStateAndCity.state;
          this.patientInformationFormData.city = this.getStateAndCity.city;
          await this.onBlurAddress();
        } else {
          if (!this.getStateAndCity && params.zip.length == 5) {
            this.$message({
              message: "No State & City Found",
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    parsePatientInfo(patientInfo) {
      let params = { ...patientInfo };
      if (!params.work_phone) delete params.work_phone;
      if (!params.middle_name) delete params.middle_name;
      if (!params.home_phone) delete params.home_phone;
      if (!params.address_line_1) delete params.address_line_1;
      if (!params.address_line_2) delete params.address_line_2;
      if (!params.race) delete params.race;
      if (!params.ethnicity) delete params.ethnicity;
      if (!params.pregnant) delete params.pregnant;

      if (params.email) {
        params.email = params.email.toLowerCase();
      }
      return params;
    },
  },
};
</script>
